import { pki } from 'node-forge';

export type CertInfo = {
  notAfter: any;
  subject: any;
  serialNumber: any;
};

export function extractCertInfo(pem: string): CertInfo {
  const certificate = pki.certificateFromPem(pem);
  return {
    notAfter: certificate.validity.notAfter,
    subject: certificate.subject.attributes.map((attr) => `${attr.shortName}=${attr.value}`).join(', '),
    serialNumber: certificate.serialNumber,
  };
}

